import type { KnowledgeBase, KbDocument } from '../types';
import { api } from './apiClient';

export const knowledgeBasesService = {
  async list(): Promise<KnowledgeBase[]> {
    const res = await api.get<{ knowledgeBases: KnowledgeBase[] }>('/knowledge-bases');
    return res.knowledgeBases;
  },

  async save(kb: Partial<KnowledgeBase>): Promise<KnowledgeBase> {
    const res = await api.post<{ knowledgeBase: KnowledgeBase }>('/knowledge-bases', kb);
    return res.knowledgeBase;
  },

  async remove(id: string): Promise<void> {
    await api.del(`/knowledge-bases/${encodeURIComponent(id)}`);
  },

  async listDocs(kbId: string): Promise<KbDocument[]> {
    const res = await api.get<{ documents: KbDocument[] }>(`/knowledge-bases/${encodeURIComponent(kbId)}/documents`);
    return res.documents;
  },

  async uploadDocs(kbId: string, files: File[]): Promise<KbDocument[]> {
    const form = new FormData();
    files.forEach((f) => form.append('files', f));
    const res = await api.upload<{ documents: KbDocument[] }>(`/knowledge-bases/${encodeURIComponent(kbId)}/documents`, form);
    return res.documents;
  },

  async removeDoc(kbId: string, docId: string): Promise<void> {
    await api.del(`/knowledge-bases/${encodeURIComponent(kbId)}/documents/${encodeURIComponent(docId)}`);
  },
};
